import { Space } from "antd";

const InfoCard = ({ icon, label, title }) => {
  return (
    <>
      <Space className="w-1/2 flex justify-start">
        <div className="flex items-center gap-4">
          <div className="w-[45px] h-[45px] bg-[#A334341A] flex justify-center items-center rounded-full">
            {icon}
          </div>
          <p className="text-[#000000] leading-6 text-left text-sm">
            {label}
            <br />
            <strong className="text-xl">{title}</strong>{" "}
          </p>
        </div>
      </Space>
    </>
  );
};

export default InfoCard;
